// NOTE: currently this API is only available on vX
export const API_VERSION = 'vX'
export const USERS_STATE_CLEAR_DELAY = 5000
export const DEFAULT_USERS_BATCH_SIZE = 100
